import capitalize from 'lodash/capitalize';
import startCase from 'lodash/startCase';

// TODO: Move to web/ui-utils
export const screamingSnakeCaseToTitle = (enumValue: string) => {
  return startCase(enumValue.toLowerCase().replace('_', ' '));
};

export const screamingSnakeCaseToText = (enumValue: string) => {
  return capitalize(enumValue.toLowerCase().replace('_', ' '));
};
export const textToScreamingSnakeCase = (text?: string | null) => {
  if (!text) {
    return '';
  }

  return text
    .trim()
    .replace(/[\s-]+/gu, '_')
    .toUpperCase();
};
